module.exports = __webpack_public_path__ + "static/img/gzhqrcode-logo.b340dbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gzhqrcode-logo.svg
// module id = 3oPC
// module chunks = 89